export const INVALID_ANSWERS = [
  'K+ ha sido entrenado para responder cuestiones en el ámbito regulatorio con información fiable y actualizada. No puedo ofrecer documentación sobre esos temas.',
  'K+ ha sido entrenado para responder cuestiones en el ámbito regulatorio con información fiable y actualizada. Tu pregunta excede mi entrenamiento actual, por favor consulta en el contenido de tu producto Aranzadi LA LEY',
  'K+ ha sido entrenado para responder cuestiones en el ámbito regulatorio con información fiable y actualizada. Tu pregunta excede mi entrenamiento actual, pero te indico documentación de Aranzadi LA LEY que te puede resultar de interés.'
];

export function isValidAnswer(answer: string): boolean {
  const trimmed = answer.trim();
  const isExactInvalid = INVALID_ANSWERS.some((invalid) => invalid === trimmed);
  const isPotentialError = INVALID_ANSWERS.some((invalid) =>
    invalid.startsWith(trimmed)
  );
  return !isExactInvalid && !isPotentialError && trimmed !== '';
}
